export default defineNuxtPlugin(() => {
  const width = useState('viewportWidth', () => (import.meta.client ? window?.innerWidth : 0))

  const updateWidth = () => {
    width.value = window?.innerWidth
  }

  let frame: number | null = null
  const onResize = () => {
    if (frame) return
    frame = requestAnimationFrame(() => {
      updateWidth()
      frame = null
    })
  }

  // ensure correct value before mount/hydration
  updateWidth()

  // attach listeners when the app mounts; provide cleanup and HMR safety
  const nuxtApp = useNuxtApp()
  let cleanup: (() => void) | undefined

  nuxtApp.hook('app:mounted', () => {
    updateWidth()
    window?.addEventListener('resize', onResize, { passive: true })
    window?.addEventListener('orientationchange', onResize, { passive: true })
    cleanup = () => {
      window?.removeEventListener('resize', onResize)
      window?.removeEventListener('orientationchange', onResize)
      if (frame) {
        cancelAnimationFrame(frame)
        frame = null
      }
    }
  })

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      cleanup?.()
    })
  }

  const breakpoint = computed(() => {
    const w = width.value
    return w < 640 ? 'sm'
      : w < 768 ? 'md'
        : w < 1024 ? 'lg'
          : w < 1280 ? 'xl'
            : '2xl'
  })

  return {
    provide: {
      viewportWidth: computed(() => width.value),
      viewportBreakpoint: breakpoint,
      viewportMobile: computed(() => width.value <= 768),
    }
  }
})
